<h2>Allergies</h2>

<xui-mat-autocomplete placeholder="Search Allergies"
  [alwaysShowAddCard]="true" [searchObservable]="searchAllergies$"
  (addNewItem)='onAddNewItem()' [addItemCardText]="'Add new allergy.'"
  [displayResultsCardTemplate]='displayResultsCardTemplate'
*xuiPermissionRequired="'Clinical.AllergyListing.Write'; condition: !readonly"></xui-mat-autocomplete>
<ng-template #displayResultsCardTemplate let-result="result" let-queryText="queryText">
  <div class="d-flex flex-row justify-content-between align-items-center">
    <span [innerHtml]="result.allergy | textHighlight: queryText"></span>
    <button mat-icon-button (click)="onItemSelected(result)"><mat-icon>add</mat-icon></button>
  </div>
  <mat-form-field color="primary" appearance="fill" class="compact w-100" subscriptSizing="dynamic">
    <mat-label>Comments/Notes</mat-label>
    <input matInput type="text" [(ngModel)]="result.comment"/>
  </mat-form-field>
</ng-template>

@if (loading) {
  <xui-loading-spinner></xui-loading-spinner>
}

<div class="mat-card-list" *xuiPermissionRequired="'Clinical.AllergyListing.Read'; condition: !readonly">
  @for (item of allergies(); track item.id) {
    <mat-card class="compact">
      <app-allergy-item [item]="item" [usePrimaryText]="settings.themeWidgetText" class="w-100"></app-allergy-item>
    </mat-card>
  }

  @if (!hasAllergies) {
    <mat-card>
      <mat-card-content>
        <span>No allergies have been added to this patient.</span>
      </mat-card-content>
    </mat-card>
  }
</div>

@if (readonly) {
  <mat-list class="allergy-readonly-list">
    @for (item of allergies(); track item.id) {
      <mat-list-item class="compact">
        <mat-icon class="ms-0 me-3" matListItemIcon>warning</mat-icon>
        <div matListItemTitle>{{item.allergy}}</div>
      </mat-list-item>
    }
    @if (!hasAllergies) {
      <mat-list-item class="mat-list-item-lines-wrap ps-0">
        <div matListItemTitle>No allergies have been added to this patient.</div>
      </mat-list-item>
    }
  </mat-list>
}
